<!-- 150 & 147 & 154 -->
<boi-form-numeric-input
  [isCurrency]="true"
  [labelName]="
    hasAmountValue || hasAmountAndDescriptionValue
      ? referenceDataLabels.AmountPerMonth
      : referenceDataLabels.MonthlyPayment
  "
  [(value)]="outgoing.MonthlyPayment"
  [fieldMaxLength]="8"
  [isReadonly]="outgoing.IsIgnored"
  [propertyNames]="[
    'Applicant_' + validationApplicantIndex + '.OutstandingDebt_' + validationOutstandingIndex + '.MonthlyPayment'
  ]"
>
</boi-form-numeric-input>

<ng-container *ngIf="!(hasAmountValue || hasAmountAndDescriptionValue)">
  <!-- 151 -->
  <boi-form-text-input
    [labelName]="referenceDataLabels.NameOfLender"
    [propertyNames]="[
      'Applicant_' + validationApplicantIndex + '.OutstandingDebt_' + validationOutstandingIndex + '.NameOfLender'
    ]"
    [(value)]="outgoing.NameOfLender"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [isReadonly]="outgoing.IsIgnored"
    [fieldMaxLength]="30"
  >
  </boi-form-text-input>

  <!-- 152 -->
  <boi-form-numeric-input
    [isCurrency]="true"
    [labelName]="referenceDataLabels.BalanceCurrentlyOutstanding"
    [(value)]="outgoing.BalanceCurrentlyOutstanding"
    [fieldMaxLength]="7"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [isReadonly]="outgoing.IsIgnored"
    [propertyNames]="[
      'Applicant_' +
        validationApplicantIndex +
        '.OutstandingDebt_' +
        validationOutstandingIndex +
        '.BalanceCurrentlyOutstanding'
    ]"
  >
  </boi-form-numeric-input>

  <ng-container *ngIf="mortgageApplication.IsFactFind">
    <!-- 152.2 -->
    <boi-form-radio-button
      [labelName]="referenceDataLabels.IsPayedOffWithMortgage"
      [controlId]="referenceDataLabels.IsPayedOffWithMortgage + '_' + validationOutstandingIndex"
      [propertyNames]="[
        'Applicant_' +
          validationApplicantIndex +
          '.OutstandingDebt_' +
          validationOutstandingIndex +
          '.IsPayedOffWithMortgage'
      ]"
      [optionList]="referenceDataOptionLists.AnswerType"
      [(value)]="outgoing.IsPayedOffWithMortgage"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [isReadonly]="outgoing.IsIgnored"
    >
    </boi-form-radio-button>

    <!-- 152.3 -->
    <boi-form-radio-button
      [labelName]="referenceDataLabels.IsSecuredAgainstProperty"
      [controlId]="referenceDataLabels.IsSecuredAgainstProperty + '_' + validationOutstandingIndex"
      [propertyNames]="[
        'Applicant_' +
          validationApplicantIndex +
          '.OutstandingDebt_' +
          validationOutstandingIndex +
          '.IsSecuredAgainstProperty'
      ]"
      [optionList]="referenceDataOptionLists.AnswerType"
      [(value)]="outgoing.IsSecuredAgainstProperty"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [isReadonly]="outgoing.IsIgnored"
    >
    </boi-form-radio-button>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.IsFullApp">
    <ng-container *ngIf="hasCreditLimit">
      <!-- 153.2 -->
      <boi-form-numeric-input
        [isCurrency]="true"
        [labelName]="referenceDataLabels.CreditLimit"
        [(value)]="outgoing.CreditLimitOrOriginalAmount"
        [fieldMaxLength]="7"
        [propertyNames]="[
          'Applicant_' +
            validationApplicantIndex +
            '.OutstandingDebt_' +
            validationOutstandingIndex +
            '.CreditLimitOrOriginalAmount'
        ]"
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [isReadonly]="outgoing.IsIgnored"
      >
      </boi-form-numeric-input>
    </ng-container>

    <ng-container *ngIf="hasOverDraftLimit">
      <!-- 153.3  -->
      <boi-form-numeric-input
        [isCurrency]="true"
        [labelName]="referenceDataLabels.OverdraftLimit"
        [(value)]="outgoing.OverdraftLimit"
        [fieldMaxLength]="7"
        [propertyNames]="[
          'Applicant_' + validationApplicantIndex + '.OutstandingDebt_' + validationOutstandingIndex + '.OverdraftLimit'
        ]"
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [isReadonly]="outgoing.IsIgnored"
      >
      </boi-form-numeric-input>
    </ng-container>
  </ng-container>

  <!-- 153 -->
  <boi-form-radio-button
    [controlId]="index"
    [labelName]="referenceDataLabels.IsThisToBeRepaidByTheTime"
    [propertyNames]="[
      'Applicant_' + validationApplicantIndex + '.OutstandingDebt_' + validationOutstandingIndex + '.MortgagePayOffCode'
    ]"
    [optionList]="referenceDataOptionLists.AnswerType"
    [(value)]="outgoing.MortgagePayOffCode"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [isReadonly]="outgoing.IsIgnored"
  >
  </boi-form-radio-button>
</ng-container>

<!-- 149.1 & 149.2 & 149.3 & 149.4 -->
<ng-container *ngIf="mortgageApplication.Applicants.length > 1">
  <ng-template [ngIf]="!hasCreditLimit" [ngIfElse]="whoIsPrimarilyResponsible">
    <boi-contextual-help-container [contextualHelpName]="referenceDataLabels.OutgoingsAppliesTo">
      <div class="form-element app applicant-checkbox p-15 d-flex flex-column flex-md-row">
        <div class="form-label align-items-start">
          <label class="bo-label-text" [innerHtml]="referenceDataLabels.OutgoingsAppliesTo | localizeLabel"></label>
        </div>
        <div class="form-input-container display-column">
          <div
            *ngFor="let applicant of mortgageApplication.Applicants; index as i"
            class="applicant-selection-container mb-15"
          >
            <label class="checkbox-input">
              <input
                kendoCheckbox
                type="checkbox"
                class="k-checkbox mr-15"
                [id]="'outgoing' + outgoing.OutstandingDebtID + 'applicant' + i"
                [ngModel]="isOutgoingApplyedToApplicant(applicant)"
                (ngModelChange)="applyedToSelectionChanged($event, applicant)"
                [disabled]="
                  isApplicantCheckboxDisabled(applicant) ||
                  mortgageApplication?.IsApplicationReadOnly ||
                  outgoing.IsIgnored
                "
              />
              <label class="bo-info-text" [for]="'outgoing' + outgoing.OutstandingDebtID + 'applicant' + i"
                >{{ applicant.Forename }} {{ applicant.Surname }}</label
              >
            </label>
          </div>
        </div>
      </div>
      <boi-tooltip [tooltipName]="referenceDataLabels.OutgoingsAppliesTo"></boi-tooltip>
    </boi-contextual-help-container>
  </ng-template>

  <ng-template #whoIsPrimarilyResponsible>
    <boi-contextual-help-container [contextualHelpName]="referenceDataLabels.WhoIsPrimarilyResponsible">
      <div class="form-element app applicant-checkbox p-15 d-flex flex-column flex-md-row">
        <div class="form-label align-items-start">
          <label
            class="bo-label-text"
            [innerHtml]="referenceDataLabels.WhoIsPrimarilyResponsible | localizeLabel"
          ></label>
        </div>
        <div class="form-input-container display-column">
          <div
            *ngFor="let applicant of mortgageApplication.Applicants; index as i"
            class="applicant-selection-container my-15"
          >
            <label>
              <input
                type="radio"
                [id]="'outgoing' + outgoing.OutstandingDebtID + 'applicant' + i"
                [checked]="isOutgoingApplyedToApplicant(applicant)"
                (change)="primarilyResponsibleSelectionChanged(applicant)"
                class="k-radio mr-15"
                [disabled]="mortgageApplication?.IsApplicationReadOnly || outgoing.IsIgnored"
              />
              <span class="k-radio-label bo-info-text">{{ applicant.Forename }} {{ applicant.Surname }}</span>
            </label>
          </div>
        </div>
      </div>
      <boi-tooltip [tooltipName]="referenceDataLabels.WhoIsPrimarilyResponsible"></boi-tooltip>
    </boi-contextual-help-container>
  </ng-template>
</ng-container>

<ng-container *ngIf="hasAmountAndDescriptionValue">
  <!-- 153.1 -->
  <boi-form-textarea
    [labelName]="referenceDataLabels.OutgoingPleaseProvideDetails"
    [(value)]="outgoing.OutstandingDetails"
    [fieldMaxLength]="1500"
    [propertyNames]="[
      'Applicant_' + validationApplicantIndex + '.OutstandingDebt_' + validationOutstandingIndex + '.OutstandingDetails'
    ]"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [isReadonly]="outgoing.IsIgnored"
  >
  </boi-form-textarea>
</ng-container>
